import { loader } from "routes/data-routes/billing-data/active-subscription/loader";
import { action } from "routes/data-routes/billing-data/active-subscription/action";
import { useActiveSubscription as hook } from "routes/data-routes/billing-data/active-subscription/useActiveSubscription";
import { ActiveSubscriptionDataRoutePath, ActiveSubscriptionDataRouteType } from "routes/data-routes/billing-data/active-subscription/route.meta";


const ActiveSubscriptionDataRouteDefinition: ActiveSubscriptionDataRouteType = {
  route: {
    path: ActiveSubscriptionDataRoutePath,
    loader: loader,
    action: action
  },
  useActiveSubscription: hook
};

export const { route: ActiveSubscriptionDataRoute, useActiveSubscription } = ActiveSubscriptionDataRouteDefinition;
